import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from '../components/FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'

@inject('dataFlowMonitoringConfigStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {dataFlowMonitoringConfigStore} = this.props
    dataFlowMonitoringConfigStore.onSearchJobAction({page: 1, size: PAGE_SIZE_DEFAULT})
    dataFlowMonitoringConfigStore.onOptionsAction()
    dataFlowMonitoringConfigStore.getAuditUsers()
  }

  handleSearch = () => {
    const {dataFlowMonitoringConfigStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'name': fieldsValue.name,
        'type': fieldsValue.type,
        'noticeType': fieldsValue.noticeType,
        'users': fieldsValue.users,
        'enable': fieldsValue.enable,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      dataFlowMonitoringConfigStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {dataFlowMonitoringConfigStore, location, t} = this.props
    const {auditLogsUserList} = dataFlowMonitoringConfigStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="name" label={t(`dataFlowMonitoringConfig.dataFlowName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`dataFlowMonitoringConfig.dataFlowName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="type" label={t(`dataFlowMonitoringConfig.dataFlowType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="0" value={0}>{t(`dataFlowMonitoringConfig.realTimeMonitoring`)}</Select.Option>
                  <Select.Option key="1" value={1}>{t(`dataFlowMonitoringConfig.regularMonitoring`)}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="noticeType" label={t(`dataFlowMonitoringConfig.notificationChannels`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  <Select.Option key="1" value='DING_TALK_ROBOT'>{t(`dataFlowMonitoringConfig.dingding`)}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="users" label={t(`dataFlowMonitoringConfig.notificationUser`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {auditLogsUserList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.shortName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="enable" label={t(`dataFlowMonitoringConfig.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="0" value={0}>{t(`general.enable`)}</Select.Option>
                  <Select.Option key="1" value={1}>{t(`general.disable`)}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
